import {
  Alert,
  Box,
  Button,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import DetailsBox from '../../../components/Cards/DetailsBox'
import AddIcon from '@mui/icons-material/Add'
import ContactsIcon from '@mui/icons-material/Contacts'
import CustomDataGrid from '../../../components/DataGrid/CustomDataGrid'
import BigModal from '../../../components/Modals/BigModal'
import AddNewContact from './AddNewContact'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const Contacts = ({ client, loadEvent }) => {
  const [openAddNew, setOpenAddNew] = useState(false)
  const [selectedContact, setSelectedContact] = useState(null)
  return (
    <DetailsBox
      title="Contacts"
      buttonRight={
        <Button
          endIcon={<ContactsIcon />}
          color="contrast"
          onClick={() => setOpenAddNew(true)}
        >
          Add a Contact
        </Button>
      }
    >
      <CustomDataGrid
        rows={client.contacts ?? []}
        columns={[
          {
            field: 'name',
            valueGetter: (value, row) =>
              (row?.userAccount?.firstName ?? row?.noAccount?.firstName ?? '') +
              ' ' +
              (row?.userAccount?.lastName ?? row?.noAccount?.lastName ?? ''),
            headerName: 'Name',
            minWidth: 200,
            flex: 1,
          },
          {
            field: 'companyRole',
            headerName: 'Role',
            minWidth: 200,
            flex: 1,
          },
          {
            field: 'email',
            flex: 1,
            valueGetter: (value, row) =>
              row?.userAccount?.email ?? row?.noAccount?.email ?? '',
            headerName: 'Email',
            minWidth: 180,
          },
          { field: 'phone', headerName: 'Phone', minWidth: 200 },
          {
            field: 'hasUserAccount',
            headerName: 'Access',
            headerAlign: 'center',
            minWidth: 120,
            valueGetter: (value, row) => (row?.userAccount ? true : false),
            renderCell: ({ row }) => (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
              >
                <Tooltip
                  title={`${
                    row?.userAccount ? 'Has ' : 'Does not have '
                  } a user account`}
                >
                  {row?.userAccount ? <CheckCircleIcon color="success" /> : ''}
                </Tooltip>
              </Box>
            ),
          },
        ]}
        getRowId={(row) => row._id}
        maxHeight={300}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        slots={{
          footer: () => null,
          toolbar: () => null,
          noRowsOverlay: () => <Alert severity="info">No Contacts Yet</Alert>,
        }}
        onRowClick={({ row }) => setSelectedContact(row)}
      />
      <BigModal
        open={openAddNew || !!selectedContact}
        onClose={() => {
          setOpenAddNew(false)
          setSelectedContact(null)
        }}
      >
        <AddNewContact
          client={client}
          setOpenAddNew={setOpenAddNew}
          loadEvent={loadEvent}
          existingContact={selectedContact}
          customCallbackAction={() => {
            setSelectedContact(null)
            loadEvent()
          }}
        />
      </BigModal>
    </DetailsBox>
  )
}

export default Contacts
